import { useState } from "react";
import Input from "../../../../componentes/input/input";
import Textarea from "../../../../componentes/input/textarea";
import { CustomDropdown } from "../../../../componentes/dropdown/CustomDropdown";
import AcaoButtons from "../../Shared/AcaoButtons";
import { SETOR_OPTIONS } from "../../../../utils/solicitacoes/setores";

const SIM_NAO_OPTIONS = [
    { value: true, label: "Sim" },
    { value: false, label: "Não" },
];

const TIPO_SELECAO_OPTIONS = [
    { value: "INTERNA", label: "Interna" },
    { value: "EXTERNA", label: "Externa" },
];

// Etapa "Análise do RH" da Solicitação de Pessoal — registra o resultado da seleção e conclui a
// solicitação numa única ação (a decisão já está expressa em "seleção aprovada para início",
// não numa escolha separada de Aprovar/Reprovar).
export default function EtapaSolicitacaoPessoalAnaliseRH({ acoes = [], acaoEmExecucao, onExecutarAcao }) {
    const [selecaoAprovadaInicio, setSelecaoAprovadaInicio] = useState(null);
    const [tipoSelecao, setTipoSelecao] = useState(null);
    const [cargoPreenchido, setCargoPreenchido] = useState("");
    const [area, setArea] = useState("");
    const [salario, setSalario] = useState("");
    const [dataAdmissao, setDataAdmissao] = useState("");
    const [justificativa, setJustificativa] = useState("");

    const valido = selecaoAprovadaInicio === true
        ? (tipoSelecao && cargoPreenchido.trim() && area.trim() && salario && dataAdmissao)
        : selecaoAprovadaInicio === false
            ? justificativa.trim()
            : false;

    function executar(acao) {
        if (!valido) return;
        const dados = selecaoAprovadaInicio
            ? {
                selecaoAprovadaInicio: true,
                tipoSelecao,
                cargoPreenchido,
                area,
                salario: Number(salario),
                dataAdmissao,
            }
            : {
                selecaoAprovadaInicio: false,
                justificativaSelecaoNaoRealizada: justificativa,
            };
        onExecutarAcao(acao, { dados });
    }

    return (
        <div className="flex flex-col gap-4">
            <div>
                <label className="text-sm font-medium text-foreground/80 block mb-1.5">
                    Seleção aprovada para início <span className="text-destructive">*</span>
                </label>
                <CustomDropdown value={selecaoAprovadaInicio} onChange={e => setSelecaoAprovadaInicio(e.value)} options={SIM_NAO_OPTIONS} placeholder="Selecione" />
            </div>

            {selecaoAprovadaInicio === true && (
                <div className="flex flex-col gap-4 border-l-2 border-primary/30 pl-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <CustomDropdown label="Tipo de seleção" required value={tipoSelecao} onChange={e => setTipoSelecao(e.value)} options={TIPO_SELECAO_OPTIONS} placeholder="Selecione" />
                        <Input label="Cargo preenchido" required value={cargoPreenchido} onChange={e => setCargoPreenchido(e.target.value)} />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        <CustomDropdown label="Área" required value={area} onChange={e => setArea(e.value)} options={SETOR_OPTIONS} placeholder="Selecione" />
                        <Input type="number" min="0" step="0.01" label="Salário" required value={salario} onChange={e => setSalario(e.target.value)} />
                        <Input type="date" label="Data de admissão" required value={dataAdmissao} onChange={e => setDataAdmissao(e.target.value)} />
                    </div>
                </div>
            )}

            {selecaoAprovadaInicio === false && (
                <div className="border-l-2 border-primary/30 pl-4">
                    <Textarea label="Justificativa" required value={justificativa} onChange={e => setJustificativa(e.target.value)} rows={3}
                        placeholder="Explique por que a seleção não foi realizada..." />
                </div>
            )}

            <AcaoButtons acoes={acoes} acaoEmExecucao={acaoEmExecucao} onAcao={executar} disabled={!valido} />
        </div>
    );
}
